import { ReactNode, createContext, useCallback, useContext, useState } from 'react';

export type ProductModalContextProps = {
  productColorId?: string;
  openByColorId: (payload: string) => void;
  close: () => void;
  changeProductColorId: (id: string) => void;
};

interface ProductModalContextProviderProps {
  children: ReactNode;
}

const ProductModalContext = createContext({} as ProductModalContextProps);

export const ProductModalContextProvider: React.FC<ProductModalContextProviderProps> = ({
  children,
}) => {
  const [productColorId, setProductColorId] = useState<string | undefined>(undefined);

  const openByColorId = useCallback(
    (newProductColorId: string) => setProductColorId(newProductColorId),
    [],
  );

  const close = () => {
    setProductColorId(undefined);
  };

  const value = {
    productColorId,
    openByColorId,
    close,
    changeProductColorId: setProductColorId,
  };

  return <ProductModalContext.Provider value={value}>{children}</ProductModalContext.Provider>;
};

export const useProductModalContext = () => useContext(ProductModalContext);
